import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { patientNamespace } from "@/store/modules/patient";
import { CaseState } from "@/store/types";
import { Patient } from "@/store/modules/patient/types";

@Component({})
export default class GridCard extends Vue {
  MAX_ROOM_EMPTY_TIME = 5400;
  @Getter("caseState", patientNamespace)
  caseStates!: Array<CaseState>;

  @Prop(Object)
  data!: Patient;

  getAbbrev(caseStateIndex: number) {
    return this.caseStates[caseStateIndex].abbrev;
  }
}
